module.exports = __webpack_public_path__ + "b636a4b4c2d8b718323b904c25d2b557.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/empty-state/dashboard.png
// module id = 1554
// module chunks = 0